import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Link } from "gatsby";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><strong parentName="p">{`To jump straight into our training, please submit your request using `}<Link to="https://bit.ly/curamcourserequest" target="new" mdxType="Link">{`this form`}</Link>{`.`}</strong></p>
    <h2>{`Available Courses`}</h2>
    <p>{`The following is a comprehensive list of the courses we offer, available as Self-Paced (or Instructor-Led) training. Please bookmark this page as the list will change over time.`}</p>
    <p><strong parentName="p">{`To get a better understanding of what courses to take, and in what order, we strongly advise reviewing the `}<a parentName="strong" {...{
          "href": "/wh-support-docs/pdf/education/C%C3%BAram_TrainingPaths_Courses.pdf"
        }}>{`Cúram_TrainingPaths_Courses.pdf`}</a>{` guide carefully (recommend you open in a new tab).`}</strong></p>
    <p><strong parentName="p">{`Please note the recommended prerequisites for each course listed below. These will help you to assess whether you have the appropriate knowledge and experience to benefit from the course.`}</strong></p>
    <h2>{`Courses For Business Users`}</h2>
    <h3>{`CUR087 Introduction to the Merative Cúram Platform 8.X: Functional Overview.`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 5 hours approx`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` Merative Cúram offers products that Social Enterprise agencies need to provide government-funded social, health,
and other services to citizens. The course provides a high-level summary of the Cúram Platform and the Cúram Application Modules. There is no lab for this course.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for Business Analysts and anyone who needs a general overview of the features and functionality
of the Cúram Platform 8.X, including testers, project managers, and product administrators.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` There are no prerequisites for this course, as it is designed to introduce learners to Cúram.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR087_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR088 Fundamentals of the Merative Cúram Platform for Business Analysts 8.X`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 40 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This self-paced course introduces the fundamentals of the Merative Cúram Platform. The course discusses out-of-the-box Cúram functionality and illustrates how it can be implemented by Social Services organizations and related agencies. This course is designed to familiarize learners with the main components of Cúram 8.X and explain how they fit together to support organizational processes.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for Business Analysts (BAs) who work on Cúram implementation projects. The course is also useful for anyone who needs an overview of the features and functionality of the Merative Cúram Platform 8.X, including testers, project managers, and administrators. In general, the contents of the course are relevant to a wider audience than BAs and will help members of that wider audience to collaborate effectively on Cúram implementation projects.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Learners should have a working knowledge of health and human services programs and exposure to and experience of typical business process analysis activities related to system implementations.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/9D88G_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR110 Introduction to Cúram Evidence (BA)`}</h3>
    <InlineNotification mdxType="InlineNotification">First published September 2025</InlineNotification>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 4 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides learners with an introduction to Evidence in Cúram. It explores the essential concept of Evidence in Cúram, as well as how Evidence relates to Cases. Learners will appreciate what it means to manage Evidence within Cases as well as the significance of what working with Temporal Evidence means in practice.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is designed to help Cúram Business Analysts and other functional/admin personnel to use, and thereby familiarize themselves with, Evidence in the Cúram Platform.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Before accessing this course, learners would have ideally completed Fundamentals of the Merative Cúram Platform for Business Analysts 8.X (CUR088), or a previous version of the Cúram Business Analyst fundamentals course.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR110_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR084 (9D84G) Cúram Solution for Child Welfare - Overview`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 3 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides an overview of the Cúram Solution for Child Welfare, which is a Merative product that is designed for organizations that provide child welfare services. The course also covers two of the six modules that the Solution contains, namely, Intake and Investigation.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for Child Welfare professionals who need to understand the features and functionality of the Cúram Solution for Child Welfare. It is also aimed at anyone who needs an introduction to the Cúram Solution for Child Welfare.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` There are no prerequisites for this course, as it is designed to introduce learners to the Cúram Solution for Child Welfare.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR084_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR085 (9D85G) Cúram Solution for Child Welfare - Modules`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 3 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course describes the features and functionality of 4 modules in the Cúram Child Welfare Solution, namely, Case Management, Legal, Collaboration, and Resource Management.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for Child Welfare professionals who need to understand the features and functionality of the Case Management, Legal, Collaboration, and Resource Management modules of the Cúram Solution for Child Welfare.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` There are no prerequisites for this course, as it is designed to introduce learners to the Cúram Solution for Child Welfare.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR085_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR102 Fundamentals of Cúram Financial Management`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 3 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` The course introduces the key elements of Cúram Financial Management, namely - Financial Component, Instruction Line Items (ILIs), Financial Instruction, Financial Instrument and Payslip. The course also provides a sample scenario that illustrates how Financial Management can facilitate the transactions that Social Services organizations need to process.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for business analysts (BA), who work on projects which involve implementing Cúram Financial Management, but is also useful for anyone looking for an overview of its features and functionality.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Learners should have a working knowledge of the Cúram platform and have ideally taken CUR087 Introduction to the Merative Cúram Platform 8.X: Functional Overview.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR102_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR105 Merative Cúram GHHS Web Design System for Designers`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 5-6 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` Teams that build Cúram-based web apps and digital service solutions must recognize that design is an essential part of making these apps and services usable. The course analyzes the importance of design in the development of usable and effective web apps and digital services. It also places the importance of design in the context of governments across the world setting up national web design systems. The course discusses the concept of web design systems and explains why governments worldwide are creating these systems.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended for a mixed audience of Business Analysts (BAs), Developers, and Graphic Designers who work on Cúram implementation projects. The course is designed for BAs, Developers, and Designers who contribute to the design of Cúram web apps or digital services as part of a multi-disciplinary development team.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Learners should have a working knowledge of health and human services programs and experience of typical business analysis activities related to system implementations.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR105_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR093 Cúram on Kubernetes for Business Consultants`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 8 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course explains the essential terminology, concepts, and business benefits of cloud, DevOps, and containerization technologies, including Docker, Kubernetes, and Helm. After introducing these concepts, the course focuses on the Cúram on Kubernetes solution and its benefits.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This introduction-level course is intended primarily for business consultants. Project managers, business analysts, and technical staff who need a high-level overview of cloud technologies and Cúram on Kubernetes will also find the content useful.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` The topics, while technical, are explained at a high level, and you do not require previous technical knowledge to understand them.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR093_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h2>{`Courses For Developers`}</h2>
    <h3>{`CUR089 Merative Cúram 8.X Technical Overview`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 16 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course describes the technologies that provide the business features for end-to-end case handling. It also describes considerations when implementing solutions, from understanding out-of-the-box artifacts to configuration, customization, deployment, and support. This course is the starting point for all Cúram technical training courses.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This introduction-level course is aimed at anyone who requires a technical overview of Cúram, including developers, architects, project executives, database administrators, testers, system administrators (technical), and other technical personnel.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Learners must have a basic understanding of n-tier application development and associated architectures, including web development technologies. Prior to taking this course, it is recommended that learners complete the `}<strong parentName="p">{`CUR087 Introduction to the Merative Cúram Platform 8.X: Functional Overview`}</strong>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR089_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR089_B Merative Cúram 8.X Technical Overview Badge`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 2 hours approx.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Description:`}</strong>{` This introductory badge allows learners to validate their understanding of the core concepts and technologies behind Merative Cúram, as well as how Cúram solutions are developed and supported in real-world environments.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Qualification:`}</strong>{` Completion of the quiz will earn the learner a Merative Cúram 8.X Technical Overview badge.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This badge is aimed at developers, architects, project executives, database administrators, testers, business analysts, system administrators, other technical personnel.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Completion of CUR089 Merative Cúram 8.X Technical Overview or equivalent knowledge of Cúram.`}</p>
      </li>
    </ul>
    <h3>{`CUR090 Merative Cúram for Developers (ADE) 8.X`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 40 -50 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides a solid grounding in the Cúram model-driven development approach and Application Development Environment (ADE). It presents an architectural overview of the Cúram application and introduces ADE features and tools for modeling, coding, building, and troubleshooting applications.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for developers and technical architects who will work on Cúram implementation projects. The course is also useful for anyone who needs a technical understanding of Merative Cúram Platform 8.X, including testers and support engineers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Learners should have a working knowledge of object-oriented concepts, Java, XML, SQL, and n-tier enterprise applications. The following course is recommended to gain a broad technical view of Cúram: `}<strong parentName="p">{`CUR089 Merative Cúram 8.X Technical Overview`}</strong>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR090_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR091 Merative Cúram for Developers (Customization) 8.X`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 40 - 50 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` Teams building Cúram solutions for customers must be able to analyze and customize out-of-the-box (OOTB) solutions. The first part of the course describes the approach that Cúram uses for customizing OOTB applications compliantly, including how to customize client and server artifacts, as well as source code and non-source code artifacts. The course also outlines how SOAP and RESTful web services are used for integrating with external applications and how custom features can be implemented using events, deferred processes, and batch processes.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for developers and technical architects who will work on Cúram implementation projects. The course is also useful for anyone who needs a technical understanding of Cúram Platform 8.X, including testers and support engineers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Before taking this course, students should have completed the following course: `}<strong parentName="p">{`CUR090 Merative Cúram for Developers (ADE) 8.X`}</strong>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR091_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR110 Introduction to Cúram Evidence`}</h3>
    <InlineNotification mdxType="InlineNotification">First published September 2025</InlineNotification>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 4 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides learners with an introduction to Evidence in Cúram. It explores the essential concept of Evidence in Cúram, as well as how Evidence relates to Cases. Learners will appreciate what it means to manage Evidence within Cases as well as the significance of what working with Temporal Evidence means in practice.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is designed to help Cúram Business Analysts and other functional/admin personnel to use, and thereby familiarize themselves with, Evidence in the Cúram Platform.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Before accessing this course, learners would have ideally completed Fundamentals of the Merative Cúram Platform for Business Analysts 8.X (CUR088), or a previous version of the Cúram Business Analyst fundamentals course.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR110_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR111 Merative Cúram Evidence for Developers`}</h3>
    <InlineNotification mdxType="InlineNotification">First published November 2025</InlineNotification>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 24 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides developers with insights and hands-on experience of configuring Evidence in Cúram. It guides developers through how to define Dynamic Evidence in Cúram, as well as how to apply Dynamic Evidence Types to existing Case Types. Learners will appreciate what it means to configure the Evidence Broker as well as how to define and use Evidence Verification functionality.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for developers and technical architects, who will work on Cúram implementation projects.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Prior to taking this course, students should have completed the CUR110 Introduction to Evidence as well as CUR090 Merative Cúram for Developers (ADE) 8.X courses.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR111_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR099 Merative Cúram Express Rules for Developers V8.X`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 32 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides students with a technical understanding of developing CER Rulesets. This course also describes how to integrate CER rules with Cúram Eligibility and Entitlement as well as Decision Details Rules used for Case Determinations. During the course, students will develop rules in XML and write unit tests to assert correct functionality.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This intermediate-level course is aimed at developers and technical architects.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` As a minumum, it is recommended that learners taking this course will have completed both `}<strong parentName="p">{`CUR090 Merative Cúram for Developers (ADE) 8.X`}</strong>{` and `}<strong parentName="p">{`CUR091 Merative Cúram for Developers (Customization) 8.X`}</strong>{`. In addition, it is advisable that learners of this course have 6 months or more hands-on Cúram development experience.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR099_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR099_B Merative Cúram Express Rules for Developers Badge`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 20 hours approx`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This badge offers students a chance to prove their knowledge of Cúram Express Rules by taking a test and demonstrating their ability to implement a real-world change to an Eligibility and Entitlement ruleset.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Qualification:`}</strong>{` Completion of the test and the practical exercise will earn the student a Merative Cúram Express Rules Core Competence badge.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This badge is aimed at developers who have completed the CUR099 Merative Cúram Express Rules for Developers V8.X course.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` As a minumum, it is recommended that students taking this badge will have completed the CUR099 Merative Cúram Express Rules for Developers V8.X course.`}</p>
      </li>
    </ul>
    <h3>{`CUR104 Merative Cúram Citizen Engagement Server-Side for Developers`}</h3>
    <InlineNotification mdxType="InlineNotification">First published November 2025</InlineNotification>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 24 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides learners with the technical skills needed to configure and customize server-side features of the Merative Cúram Citizen Engagement solution. Throughout the course, learners will gain hands-on experience with the server-side configuration and technologies that support Citizen Engagement, but also internal screening and program applications that are performed by caseworkers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is aimed at technical staff who will configure the server-side features of Citizen Engagement.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Merative Cúram Technical Overview`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR104_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR104_B Merative Cúram CE Server-Side for Developers Badge`}</h3>
    <InlineNotification mdxType="InlineNotification">First published November 2025</InlineNotification>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 4 hours approx`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Description:`}</strong>{` This badge offers learners a chance to prove their knowledge of Cúram Citizen Engagement Server-Side Development by taking a quiz and configuring a feature in a lab environment.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Qualification:`}</strong>{` Completion of the quiz and practical exercise will earn the learner a Merative Cúram CE Server-Side for Developers badge.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is aimed at technical staff who will configure the server-side features of Citizen Engagement.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Completion of CUR104 Merative Cúram Citizen Engagement Server-Side for Developers or experience of configuring Citizen Engagement/Universal Access server-side features.`}</p>
      </li>
    </ul>
    <h3>{`CUR080 (9D80G) IBM SPM Design System for Developers`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 16 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` During the course, learners will install the SPM Design System, set up the development environment, develop pages by using Design System components, integrate with the Cúram SPM server, and test their pages. At the beginning of the course, learners will review the main third-party technologies that are used during the course. At the end of the course learners will implement a prototype solution for the user experience they sketched in the pre-requisite course: Merative SPM Design System for Designers (CUR079).`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for developers and technical architects who will work on Cúram implementation projects that use the SPM Design System. This course is also useful for testers and support staff who will work with the SPM Design System.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Prior to taking this course, learners must have completed the following course: `}<strong parentName="p">{`CUR079 (9D79G) Merative SPM Design System for Designers`}</strong>{`. In addition, learners must have 6+ months’ experience of using the following technologies: HTML, CSS, JavaScript (ES6), JSX and React`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/9D80G_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR081 (9D81G) IBM Universal Access for Developers (Responsive Web Application)`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 16 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` Developers must understand the structure of the UA Responsive Web Application so that they can customize and extend it to produce high-quality citizen services. During the course, learners will install the web application, add custom pages, fetch data from the server, and manage custom state using Redux. In addition, developers will investigate the server configuration and REST APIs that are necessary to support the web application.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for developers and technical architects who will work on Cúram implementation projects that customize and extend the UA Responsive Web Application. This course is also useful for testers and support staff who will work with the UA Responsive Web Application.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Prior to taking this course, learners must have completed the following courses: `}<strong parentName="p">{`CUR079 (9D79G) IBM SPM Design System for Designers`}</strong>{` and `}<strong parentName="p">{`CUR080 (9D80G) IBM SPM Design System for Developers`}</strong>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/9D81G_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR082 (9D82G) IBM Cúram SPM Intelligent Evidence Gathering (IEG) for Developers 7.X`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 24 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` Intelligent Evidence Gathering (IEG) is a Cúram technology that is used to create dynamic scripts. IEG is used by Cúram applications to gather data from internal workers and citizens who use fixed and mobile devices. This course describes how to develop IEG scripts and integrate these scripts into Cúram applications.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for developers and technical architects who will work on Cúram implementation projects. The course is also useful for anyone who needs a technical understanding of IEG.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Prior to taking this course, it is recommended that learners complete the following legacy course: `}<strong parentName="p">{`CUR076 (9D76G) Merative Social Program Management (SPM) 7.X Technical Overview`}</strong>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/9D82G_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR086 Cúram on Kubernetes for Developers`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 16 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides the essential knowledge and resources to help technical roles implement and manage Cúram deployments on Kubernetes.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This is a technical course and is suited to learners with a technical background, such as developers, architects, DevOps engineers, and system administrators.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` None`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR086_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR062 (9D62G) Merative Cúram Batch Processing for Developers`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 2 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` The course provides an overview of batch processing in Cúram. It also describes how batch jobs are developed and how streaming and chunking architecture can be used to improve performance. Finally, the course describes how SPM batch processes use the DB-JMS to access application server functions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for developers and technical architects who will work on Cúram implementation projects.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Before taking this course, students should have completed the following course: `}<strong parentName="p">{`CUR090 Merative Cúram for Developers (ADE) 8.X`}</strong>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR062_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR068 (9D68G) Merative Cúram - Developing REST APIs`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 8 - 10 hours`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Course description:`}</strong>{` This course provides students with a technical understanding of developing REST APIs for Cúram Social Program Management (SPM) and how to develop REST APIs for Cúram by using recommended practices. During the course, students will design and implement a simple REST API.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This course is intended primarily for developers and technical architects.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Prerequisites:`}</strong>{` Before taking this course, students should have completed the following course: `}<strong parentName="p">{`CUR090 Merative Cúram for Developers (ADE) 8.X`}</strong>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/9D68G_Abstract.pdf"
          }}>{`Course Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR052 (9D52G) IBM Cúram Workflow for Developers 6.0.5`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li"><a parentName="strong" {...{
            "href": "mailto:curameducation@merative.com"
          }}>{`Contact`}</a>{` for more details`}</strong></li>
    </ul>
    <h2>{`Practice Environments`}</h2>
    <p>{`Many courses listed above have eLab environments associated with them. The practice environments (sandboxes) listed below are available for separate access and do not include any training materials.`}</p>
    <p>{`They are provided only to practice skills and complete exercises and are not associated directly with a course. Note that they are not externally connected to the Internet for data transfers, such as, import, updates, exports, and APIs. However, they do contain recent installations of the Cúram Platform to allow for business and developer practice activities.`}</p>
    <p>{`Special-purpose sandboxes can be provisioned by request. Please contact `}<a parentName="p" {...{
        "href": "mailto:curameducation@merative.com"
      }}>{`curameducation@merative.com`}</a>{` for more information.`}</p>
    <h3>{`CUR097 Merative Cúram Development Environment 8.X for BAs: Sandbox`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 50 hours access`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Lab description:`}</strong>{` The sandbox provides learners with on-demand access to the Merative Cúram Platform 8.X development environment. This environment is used in the Fundamentals of the Merative Cúram Platform for Business Analysts 8.X course (CUR088). The Sandbox enables students to explore some of the functionality and features covered by the course. This lab is accompanied by the CUR088 lab exercise guide but there is no course book or training curriculum provided.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This lab is intended primarily for Cúram Business Analysts and other functional/admin personnel who need to use and familiarize themselves with the Merative Cúram SPM Platform V8.X . The Sandbox is also useful for people who are preparing for the Cúram V8.X BA Certification Test.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR097_Abstract.pdf"
          }}>{`Lab Env Abstract`}</a></p>
      </li>
    </ul>
    <h3>{`CUR092 Merative Cúram Development Environment 8.X for Developers: Sandbox`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Duration:`}</strong>{` 50 hours access`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Lab description:`}</strong>{` The sandbox provides learners with on-demand access to the Merative Cúram Platform 8.X development environment. This environment is used in the Merative Cúram for Developers (ADE) 8.X course (CUR090) and Merative Cúram for Developers (Customization) 8.X course (CUR091). The Sandbox enables students to explore the functionality and features covered by the courses.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Audience:`}</strong>{` This lab is intended primarily for Cúram developers and technical architects, who need to use and familiarize themselves with the Merative Cúram SPM Platform V8.X. The Sandbox is also useful for people who are preparing for the Cúram V8.X Developer Certification Tests.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`More detail:`}</strong>{` `}<a parentName="p" {...{
            "href": "/wh-support-docs/pdf/education/CUR092_Abstract.pdf"
          }}>{`Lab Env Abstract`}</a></p>
      </li>
    </ul>
    <h2>{`Legacy Courses`}</h2>
    <p>{`If you need to take an older version of a training course (eg V7), please click `}<Link to="/spm/education/legacy_training_courses" mdxType="Link">{`Legacy Courses`}</Link></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      